
export const navigation = {
  'nav.home': 'Accueil',
  'nav.profile': 'Profil',
  'nav.settings': 'Paramètres',
  'nav.logout': 'Déconnexion',
  'errors.pageNotFound': 'Oups ! La page que vous recherchez n\'existe pas.',
  'nav.searchSubsidies': 'Rechercher des subventions',
  'nav.calendar': 'Calendrier',
  'nav.regulations': 'Réglementations',
  'nav.backToOverview': 'Retour à l\'aperçu',
  'navigation.dashboard': 'Tableau de bord',
  'navigation.findFunding': 'Trouver un financement',
  'navigation.profile': 'Profil',
  'navigation.settings': 'Paramètres',
  'navigation.signIn': 'Connexion',
  'navigation.signUp': 'S\'inscrire',
  'navigation.signOut': 'Se déconnecter',
  'navigation.language': 'Langue',
  'navigation.english': 'English',
  'navigation.french': 'Français',
  'navigation.aiAssistant': 'Assistant IA',
  'navigation.shortcuts': 'Raccourcis',
  'navigation.dispositifs': 'Dispositifs',
} as const;
